import { render, staticRenderFns } from "./Latam.vue?vue&type=template&id=79821017&"
import script from "./Latam.vue?vue&type=script&lang=js&"
export * from "./Latam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports